import Primus from './Primus';
import PrimusRoutes from "./PrimusRoutes"
import PrimusEditor from "./PrimusEditor"

export {
    PrimusRoutes,
    PrimusEditor
}

export default Primus;